import React from "react";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export interface SVGProps<T> extends React.SVGProps<T> {
	dataTestId?: string;
}

export interface PublicProps extends SvgIconProps {
	fill?: string;
	dataTestId?: string;
	paths: SVGProps<SVGPathElement>[];
}

export const Icon: React.FC<PublicProps> = ({
	width,
	height,
	viewBox,
	fill,
	dataTestId,
	paths,
	sx,
	...props
}) => {
	return (
		<SvgIcon
			data-testid={dataTestId}
			sx={{
				justifyContent: "center",
				alignItems: "center",
				width: `${width}px`,
				height: `${height}px`,
				...sx,
			}}
			viewBox={viewBox || `0 0 ${width} ${height}`}
			fill={fill || "none"}
			{...props}
		>
			{paths.map(({ dataTestId: testId, ...path }) => (
				<path key={path.d} data-testid={testId} {...path} />
			))}
		</SvgIcon>
	);
};
